import React, { useEffect, useState } from 'react'
import MainLayouts from '../../../layouts/MainLayouts'
import AgoraUIKit from 'agora-react-uikit';
import { Button, Drawer, Tabs } from 'antd';
import { Col, Row } from 'react-bootstrap';
import { VideoCameraAddOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { SocketIO } from '../../../services/Text/GlobalText';
import axios from 'axios';
import { BASE_URL_SOCKET } from 'services/BaseUrl';
import { APP_ID, BERDERING, DITOLAK, generateRandomText, JAWAB, SELESAI } from 'services/String/string';
import { msg } from 'services/Toastr/Notify/_Toastr';
import CountUpTimerX from 'components/count-up/CountUpTimerX';
import getQuery from 'services/Forms/LyBootstrapt';
// import { useHistory } from 'react-router-dom';
import { useHistory } from 'react-router';
import RiwayatPolaMakan from 'pages/RiwayatPolaMakan/RiwayatPolaMakan';
import FormHidanganSehari from 'pages/FormHidanganSehari/FormHidanganSehari';
import { useLocation } from 'react-router-dom';
import PerhitunganEnergiDewasa from 'pages/PerhitunganEnergi/PerhitunganEnergiDewasa';
import PerhitunganEnergyAnak from 'pages/PerhitunganEnergi/PerhitunganEnergyAnak';
import IdentitasPasien from 'pages/RiwayatPolaMakan/IdentitasPasien';
import ScreenRecorder from 'components/screenRecorder/ScreenRecorder';
import PemilihanDiet from 'pages/PerhitunganEnergi/PemilihanDiet';
import MakananYangBolehTidak from 'pages/RiwayatPolaMakan/MakananYangBolehTidak';
import REST from 'services/Api/REST';
import { PARAMS } from 'services/Api/params';
import { getDataUser } from 'services/Cache/Auth';
import JitsiEmbed from 'pages/Jitsi/JitsiEmbed.jsx';
import JitsiVC from 'pages/Jitsi/JitsiVC.jsx';
// import JitsiVC from 'pages/Jitsi/JitsiVC.jsx';

function VideoCallKonseling(pr) {

    const [videoCall, setVideoCall] = useState(true);
    const [tokenChannel, settokenChannel] = useState();
    const [berdering, setberdering] = useState(false);
    const [rtcProps, setrtcProps] = useState();
    const [status, setstatus] = useState("");

    const history = useHistory();

    const FCM_TOKEN = PARAMS.get("fcm")
    const callbacks = {
        EndCall: () => {
            try {
                // Optional: Handle manual cleanup if needed
                console.log('Call ended successfully.');
            } catch (err) {
                if (err.code === 102) {
                    console.warn('Client already logged out.');
                } else {
                    console.error('Error ending call:', err);
                    setVideoCall(false);
                }
            }
        },
    };

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const konseling_id = queryParams.get('konsId');


    const generateToken = () => {
        const channel = generateRandomText(15);
        axios.get(BASE_URL_SOCKET + "/generate-token?channel=" + channel).then(rs => {

            settokenChannel(rs.data)
            const prop = {
                appId: APP_ID,
                channel: rs.data.channel,
                token: rs.data.token,
                width: 100,
                height: 400,
            };

            setrtcProps(prop)
        })
    }

    const panggilKonseling =async () =>  {
        const DEVICE_ID = getQuery('dvId')
        if (tokenChannel) {
            const dt = {
                "title" : "Konseling Gizi RSUD H. Moh. Ruslan",
                "body" : "Silahkan di angkat ",
                "channel" : tokenChannel?.channel,
                "token_agora" : tokenChannel?.token,
                "fcm_token" : FCM_TOKEN,
                "user_id" : getDataUser(),
            }
            const rs = await REST.post("/send-fcm-notification", dt)
            const data = { ...tokenChannel, deviceid: DEVICE_ID }
            // SocketIO.emit('TRIGGER_VIDEO_CALL', data);
        }
    }

    useEffect(() => {
        generateToken()
    }, [])


    // LISTER BERDERING
    useEffect(() => {
        SocketIO.on("PANGGILAN_BERDERING", (data) => {
            if (data.status == BERDERING) {
                setberdering(true)
            }
            if (data.status == DITOLAK) {
                setberdering(false)
                msg.error('Panggilan di ' + data.status)
            }
            if (data.status == JAWAB) {
                setberdering(false)
                msg.success('Panggilan di ' + data.status)
            }
            if (data.status == SELESAI) {
                setberdering(false)
                msg.error('Panggilan di akhiri')
            }
            setstatus(data.status)

        })
    }, [])

    useEffect(() => {
        const unblock = history.block((location, action) => {
            if (action === 'POP') {
                // setVideoCall(false)
                // setrtcProps()
                return window.confirm("Anda akan meninggalkan Halahan ini ?");
            }
        });

        return () => {
            unblock(); // Clean up the block when the component unmounts
        };
    }, [history]);

    useEffect(() => {
        const handleBeforeUnload = (event) => {
          event.preventDefault();
          event.returnValue = ""; // Menampilkan pesan default browser
        };
    
        window.addEventListener("beforeunload", handleBeforeUnload);
        
        return () => {
          window.removeEventListener("beforeunload", handleBeforeUnload);
        };
      }, []);



    return (
        <MainLayouts>
            <br/>
            <IdentitasPasien konseling_id={konseling_id} />
            <ScreenRecorder konseling_id={konseling_id}  />
            {/* <ScreenRecorderMalik/> */}

            <Tabs type="card" centered>
                <Tabs.TabPane className='lh100' tab={<div className='lh100 hover p-2'> <VideoCameraAddOutlined /> <b>Video Call</b></div>} key="item-1">
                    {/* <div className='text-center mb-4'>
                        {berdering ?
                            <Button size='large' icon={<VideoCameraAddOutlined />} loading={true} type='primary'>Berdering ... </Button> :

                            status == JAWAB ? <CountUpTimerX /> :
                                <Button size='large' icon={<VideoCameraAddOutlined />} type='primary' onClick={panggilKonseling}>Panggil </Button>
                        }


                    </div>
                    {
                        videoCall && rtcProps ? (
                            <div style={{ padding: "0 300px", display: 'grid', height: '50vh', width: '100vw' }}>
                                <AgoraUIKit rtcProps={rtcProps} callbacks={callbacks} />
                            </div>
                        ) : (
                            <Button type='primary' onClick={() => setVideoCall(true)}></Button>
                        )
                    } */}

                    {/* <JitsiEmbed/> */}
                    <JitsiVC/>
                </Tabs.TabPane>
                <Tabs.TabPane className='' tab={<div className=' text-center p-2 lh100 hover'> <b>Formulir Riwayat<br />Pola Makan/ Kebiasaan </b> </div>} key="item-2">
                    <RiwayatPolaMakan konseling_id={konseling_id} />
                </Tabs.TabPane>
                <Tabs.TabPane tab={<div className='p-2 b text-center hover lh100'> Formulir<br />Hidangan Sehari ( Recall 24 Jam )</div>} key="2">
                    <FormHidanganSehari konseling_id={konseling_id} />
                </Tabs.TabPane>

                <Tabs.TabPane tab={<div className='p-2 b text-center hover lh100'> Perhitungan<br />Energi Dewasa</div>} key="3">
                    <PerhitunganEnergiDewasa konseling_id={konseling_id} />
                </Tabs.TabPane>

                <Tabs.TabPane tab={<div className='p-2 b text-center hover lh100'> Perhitungan<br />Energi Anak</div>} key="4">
                    <PerhitunganEnergyAnak konseling_id={konseling_id} />
                </Tabs.TabPane>

                <Tabs.TabPane tab={<div className='p-2 b text-center hover lh100'> Pemberian Diet </div>} key="5">
                    <PemilihanDiet konseling_id={konseling_id} />
                </Tabs.TabPane>

                <Tabs.TabPane tab={<div className='p-2 b text-center hover lh100'> Makanan<br/>Boleh/Tidak  </div>} key="6">
                    <MakananYangBolehTidak konseling_id={konseling_id} />
                </Tabs.TabPane>


            </Tabs>

            <br />




        </MainLayouts >
    )
}

export default VideoCallKonseling